import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const WarningCircle: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M12 23a11 11 0 1 1 11-11 11 11 0 0 1-11 11Zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm0 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-4a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1Z" />
  </Icon>
);

export default WarningCircle;
